import { Timestamp } from 'firebase/firestore';
import { PinType, PIN_TYPES } from './PinType';

export interface MapPin {
  id: string;
  latitude: number;
  longitude: number;
  type: PinType;
  title: string;
  description: string;
  createdBy: string;
  createdAt: Date;
  isActive: boolean;
  reportCount: number;
  imageURL?: string;
  hasLiveChat: boolean;
  verificationYes: number;
  verificationNo: number;
}

export interface MapPinDocumentData {
  id: string;
  latitude: number;
  longitude: number;
  type: string;
  title: string;
  description: string;
  createdBy: string;
  createdAt: Date | Timestamp;
  isActive: boolean;
  reportCount: number;
  imageURL?: string;
  hasLiveChat: boolean;
  verificationYes: number;
  verificationNo: number;
}

export class MapPinModel {
  static fromFirestore(data: MapPinDocumentData): MapPin {
    return {
      id: data.id,
      latitude: data.latitude,
      longitude: data.longitude,
      type: data.type as PinType,
      title: data.title,
      description: data.description,
      createdBy: data.createdBy,
      createdAt: data.createdAt instanceof Timestamp ? data.createdAt.toDate() : new Date(data.createdAt),
      isActive: data.isActive,
      reportCount: data.reportCount,
      imageURL: data.imageURL,
      hasLiveChat: data.hasLiveChat,
      verificationYes: data.verificationYes,
      verificationNo: data.verificationNo
    };
  }

  static getDisplayInfo(pin: MapPin) {
    const pinTypeInfo = PIN_TYPES[pin.type];
    return {
      ...pinTypeInfo,
      isBusiness: pin.type === PinType.BUSINESS
    };
  }
}
